import { Helmet } from "react-helmet-async";
import Screen from "../Layouts/Screen/Screen";
import ItemList from "../../components/ItemList/ItemList";
import { Archive, Award, Bell, DollarSign, FileText, Star, UserMinus, Users, UserX } from "react-feather";
import { Accessibility, PersonStanding } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { useMessage } from "../../global-components/src";
import axios from "axios";
import { useAuth } from "../../global-components/src";
import { errorMessage } from "../../utils/TextManagerTwo";
import Spinner from "../../global-components/src/components/spinner/spiner";
import { Ban } from "../../types";
import UserSearch from "../Settings/SearchScreen/User/User";
import { PACOCA_API_URL } from "../../global-components/src/utils/vars";
import { UserSearchLoadin } from "../Settings/SearchScreen/User/UserSearchLoading";
import { PostLoading } from "../../components/Post/post-loading";

const Bans = () => {
    const observerRef = useRef<IntersectionObserver | null>(null);
    const endOfListRef = useRef<HTMLDivElement | null>(null);
    const [bans, setBans] = useState<Ban[] | null>(null);
    const closeRef = useRef<HTMLButtonElement | null>(null);
    const { setMessage } = useMessage();
    const [loading, setLoading] = useState(false);
    const [end, setEnd] = useState(false);
    const [page, setPage] = useState(() => { return 1; });
    const { token } = useAuth();

    const loadData = async (newPage?: number) => {
        const currentPage = newPage ?? page + 1; // Usa newPage se fornecido, senão incrementa
        const url = PACOCA_API_URL + `/moderators/bans?page=${currentPage}`;

        if (loading || end) return;
        setLoading(true);

        try {
            const response = await axios.get(url, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            const data = response.data;

            if (data.bans.length > 0) {
                setBans((prevData) => [...(prevData || []), ...data.bans]);
            } else {
                setEnd(true);
            }

        } catch (err: any) {
            const type = err?.response?.data?.type_message || "error";
            const messageError = errorMessage(err)
            setMessage(messageError, type)
            console.error('Erro:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if(!loading && !end) loadData(page);
    }, [page]);
    

    useEffect(() => {
        const modalBody = document.getElementById("modal-comments-body");

        const handleScroll = () => {
            if (!modalBody) return;
            const { scrollTop, clientHeight, scrollHeight } = modalBody;

            if ((scrollTop + clientHeight >= scrollHeight - 50) && !end && !loading) {
                setPage((prevPage) => prevPage + 1); // Agora a página é atualizada antes da requisição
            }
        };

        if (modalBody) {
            modalBody.addEventListener("scroll", handleScroll);
            window.addEventListener("scroll", handleScroll);
        }

        return () => {
            if (modalBody) {
                modalBody.removeEventListener("scroll", handleScroll);
                window.removeEventListener("scroll", handleScroll);
            }
        };
    }, [end, loading]);
    
    return (
        <>
            <Screen paddingTopTitle={true} title="Banimentos">
                <Helmet>
                    <title>Paçoca - Banimentos</title>
                </Helmet>

                <>
                    {bans?.map((ban, index) => {
                        const cleanReason = ban.reason ? ban.reason.split(/<br\s*\/?>/i)[0].trim() : null;
                        return (
                            <div key={index}>
                                <UserSearch clasImgAccount="img-list-chat" hideFollowUser user={ban?.user} />
                                <div style={{ paddingLeft: "56px", marginTop: "-6px", marginBottom: "6px" }}>
                                    {cleanReason && (
                                        <p style={{ fontSize: "12px", opacity: 0.7, margin: 0, wordBreak: "break-word" }}>
                                            <strong>Motivo:</strong> {cleanReason}
                                        </p>
                                    )}
                                    <p style={{ fontSize: "11px", opacity: 0.5, margin: 0 }}>
                                        {ban.blocked_until
                                            ? `Até: ${new Date(ban.blocked_until).toLocaleString('pt-BR')}`
                                            : "Banimento permanente"}
                                    </p>
                                </div>
                            </div>
                        );
                    })}

                    <UserSearchLoadin loading={loading}/>

                    {(!bans && !loading) || (bans && !bans.length && !loading) ? (
                        <div className="user-select-none row mt-5">
                            <span className="span-empty">
                                <UserMinus className="icon-empty" />
                                <h3 className="w-100 text-center">Nenhuma pessoa banida</h3>
                            </span>
                        </div>
                    ): null}
                    
                    <p ref={endOfListRef}></p>
                </>
            </Screen>
        </>
    );
};

export default Bans;